/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {fetchAsyncUserDetails} from '../../../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL

const initialState = {
  changeEmail: {},
  isLoading: false,
}

export const fetchAsyncChangeEmail: any = createAsyncThunk(
  'changeEmail/fetchAsyncChangeEmail',
  async (data: any, thunkApi: any) => {
    const response = await axios.patch(`${API_URL}user/changeEmail`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

const ChangeEmailSlice = createSlice({
  name: 'changeEmail',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncChangeEmail.fulfilled]: (state, {payload}) => {
      {
        payload.status === true && toast.success(payload.message)
      }
      return {...state, changeEmail: payload}
    },
    [fetchAsyncChangeEmail.rejected]: () => {},
  },
})

export default ChangeEmailSlice.reducer
